/** Datagrid key base — full key is `${WORK_SHIFTS_DATAGRID_KEY}_${organizationId}` */
export const WORK_SHIFTS_DATAGRID_KEY = "work_shifts_grid";
